import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'cm-progress-circle',
  template: `
		<div class="progress-circle">
			<svg viewBox="0 0 36 36" class="circular-chart" [ngClass]="fill">
				<path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
				      class="circle-bg"
				      [attr.stroke]="bgColor"></path>
				<path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
				      class="circle"
				      [attr.stroke-dasharray]=" value + ',100'"></path>
				<text x="18" y="20.35" class="percentage">
					{{value ? value.toFixed(2) : 0}}%
				</text>
			</svg>
		</div>
  `,
  styles: [`
		.progress-circle {
			width: 100%;
			justify-content: space-around;
		}

		.circular-chart {
			display: block;
			margin: auto;
			max-width: 80%;
			max-height: 250px;
		}

		.circle-bg {
			fill: none;
			/*stroke: #eee;*/
			stroke-width: 2;
		}

		.circle {
			fill: none;
			/*stroke: #000;*/
			stroke-width: 3;
			stroke-linecap: round;
			animation: progress 1s ease-out forwards;
		}

		@keyframes progress {
			0% {
				stroke-dasharray: 0 100;
			}
		}

		.circular-chart.orange .circle {
			stroke: #FFC700;
		}

		.circular-chart.green .circle {
			stroke: #8BC34B;
		}

		.circular-chart.red .circle {
			stroke: #FF5B5A;
		}

		.percentage {
			fill: #666;
			font-family: sans-serif;
			font-size: 0.5em;
			text-anchor: middle;
		}
  `]
})
export class ProgressCircleComponent {

  @Input() value = 0;
  @Input() bgColor = '#eee';
  @Input() fill = 'black'; // orange, green, red

}
